import React, { useState, useEffect } from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';
import { FormGroup } from 'reactstrap';
import { Form, Input } from '@availity/form';
import Rodal from '../../../../components/Rodal/Rodal';
import { ASSOCIATE_MEMBER_ROLES_ENUM } from '../../../../utils/associateMembersConstants';

const AssociateRepresentativeModal = (props) => {
    const [selectedAssociate, setSelectedAssociate] = useState();
    const rolesAvailableForPmgRepresentativeChair = [
        ASSOCIATE_MEMBER_ROLES_ENUM.FellowPracticeOwner,
        ASSOCIATE_MEMBER_ROLES_ENUM.PracticeManager,
    ];

    const [availableMemberOptions, setAvailableMemberOptions] = useState();

    useEffect(() => {
        setAvailableMemberOptions(getAvailableMemberOptions());
    }, [props]);

    useEffect(() => {
        setSelectedAssociate(props.selectedAssociate);
    }, [props]);

    const getAvailableMemberOptions = () => {
        const result =
            props.associateMembers?.filter((member) => {
                const iNoneOption = member.id === 0;
                const targetPmgPractice = member?.practices?.find(
                    (practice) => practice.practiceId === props.practiceId
                );

                const isMemberRoleAvailable =
                    rolesAvailableForPmgRepresentativeChair.some(
                        (roleId) => roleId === targetPmgPractice?.roleId
                    );

                return iNoneOption || isMemberRoleAvailable;
            }) ?? [];

        return result;
    };

    return (
        <Rodal
            visible={props.isVisible}
            animation={'slideTop'}
            showMask={true}
            width={600}
            showCloseButton={true}
            onClose={() => {
                props.setIsVisible(false);
            }}
            className="edit_membership_profile center-modal">
            <ModalHeader>Affiliated Practice Representative</ModalHeader>
            <ModalBody>
                <b className="dynamic_data">
                    Practice owners are permitted to invite an team member to
                    assist them with Practice Management Group activities. Team
                    Members must first be registered with VetValue through the
                    Team Member Page. Due to the sensitive nature of topics
                    discussed within a PMG, all affiliated representatives must
                    be approved by VetValue and you must disclose any other
                    veterinary pratice affiliations of this team member, so that
                    VetValue can assure there are no conflicts of interest
                    vis-a-vis any other member of the PMG group.
                </b>

                <Form
                    initialValues={{
                        associate: props.selectedAssociate,
                    }}
                    onSubmit={() => {}}>
                    <FormGroup>
                        <Input
                            className="dynamic_data"
                            type="select"
                            name="associate"
                            value={selectedAssociate}
                            onChange={(event) => {
                                setSelectedAssociate(event.target.value);
                            }}>
                            {availableMemberOptions
                                ? availableMemberOptions.map(
                                      (option, index) => (
                                          <option key={index} value={option.id}>
                                              {option.name}
                                          </option>
                                      )
                                  )
                                : ''}
                        </Input>
                    </FormGroup>
                </Form>

                <div className="form-submit-btn input-group">
                    <button
                        type="button"
                        className="btn mr-2"
                        onClick={() => {
                            props.setIsVisible(false);
                        }}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-submit"
                        onClick={() => {
                            props.onSubmit(selectedAssociate);
                        }}>
                        Submit
                    </button>
                </div>
            </ModalBody>
        </Rodal>
    );
};
export default AssociateRepresentativeModal;
